module.exports = __webpack_public_path__ + "img/HeBo Trailers-15.d8739e76.jpg";